import toast from "react-hot-toast";
import mainAxios from "../redux/api/mainAxios";

export const sendPasswordResetEmail = async (email) => {
  try {
    const response = await mainAxios.post(`api/auth/forgot-password`, {
      email,
    });
    toast.success("Email envoyé");

    return response.data;
  } catch (error) {
    console.error("Error sending password reset email:", error);
    throw error;
  }
};
